/* ============================================================
   iWine - theme.js
   Powers the signature interactions: slide-out AJAX cart,
   announcement bar, reveal-on-scroll, qty steppers, mobile nav.
   No build step. Vanilla ES2017+.
   ============================================================ */
(function () {
  'use strict';

  var routes = window.iWineRoutes || {};
  var cartAddUrl = routes.cart_add_url || '/cart/add';
  var cartChangeUrl = routes.cart_change_url || '/cart/change';

  /* ---------- small helpers ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function on(el, ev, fn) { if (el) el.addEventListener(ev, fn); }

  /* ---------- optimistic UI helpers (instant feel; server syncs in background) ---------- */
  function fmtMoney(cents) { return '$' + (Math.round(cents) / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function attrCents(el, name) { return parseInt(el.getAttribute(name), 10) || 0; }
  function bumpSubtotal(deltaCents) {
    var sub = $('[data-cart-subtotal]');
    if (!sub) return;
    var next = attrCents(sub, 'data-cents') + deltaCents;
    if (next < 0) next = 0;
    sub.setAttribute('data-cents', next);
    sub.textContent = fmtMoney(next);
  }

  function fetchConfig(body) {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    };
  }

  /* Pull the fresh drawer contents (scrim + panel) out of a Section Rendering API payload.
     The payload wraps our section as <div id="shopify-section-cart-drawer"><div id="iw-cart-drawer">…</div></div>,
     so we drill to #iw-cart-drawer and return its inner HTML to swap into the live drawer. */
  function sectionInner(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector('#iw-cart-drawer');
    return el ? el.innerHTML : html;
  }

  /* ============================================================
     REVEAL ON SCROLL
     ============================================================ */
  function initReveal() {
    var nodes = $all('[data-reveal]:not(.in)');
    if (!nodes.length) return;
    if (!('IntersectionObserver' in window)) { nodes.forEach(function (n) { n.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.04 });
    nodes.forEach(function (n) { io.observe(n); });
    // Safety net: nothing should stay invisible.
    setTimeout(function () { $all('[data-reveal]:not(.in)').forEach(function (n) { n.classList.add('in'); }); }, 1800);
  }

  /* ============================================================
     ANNOUNCEMENT BAR (dismissible, remembered)
     ============================================================ */
  function initAnnounce() {
    var bar = $('[data-announce]');
    if (!bar) return;
    var key = 'iw-announce-dismissed:' + (bar.getAttribute('data-announce-id') || 'default');
    try { if (localStorage.getItem(key) === '1') { bar.hidden = true; } } catch (e) {}
    on($('[data-announce-close]', bar), 'click', function (e) {
      e.stopPropagation();
      bar.hidden = true;
      try { localStorage.setItem(key, '1'); } catch (e2) {}
    });
  }

  /* ============================================================
     MOBILE NAV
     ============================================================ */
  function initMobileNav() {
    var toggle = $('[data-menu-toggle]');
    var menu = $('[data-mobile-menu]');
    if (!toggle || !menu) return;
    on(toggle, 'click', function () {
      var open = menu.hasAttribute('hidden') ? false : true;
      if (open) { menu.setAttribute('hidden', ''); } else { menu.removeAttribute('hidden'); }
    });
  }

  /* ============================================================
     SLIDE-OUT CART
     ============================================================ */
  var Cart = {
    open: function () {
      document.body.classList.add('iw-cart-open');
      var drawer = $('#iw-cart-drawer');
      if (drawer) drawer.setAttribute('aria-hidden', 'false');
    },
    close: function () {
      document.body.classList.remove('iw-cart-open');
      var drawer = $('#iw-cart-drawer');
      if (drawer) drawer.setAttribute('aria-hidden', 'true');
    },
    /* Swap drawer contents from a Section Rendering API payload, refresh counts, bind handlers. */
    render: function (sectionsHtml) {
      var drawer = $('#iw-cart-drawer');
      if (drawer && sectionsHtml && sectionsHtml['cart-drawer']) {
        drawer.innerHTML = sectionInner(sectionsHtml['cart-drawer']);
      }
      Cart.refreshCount();
    },
    refreshCount: function () {
      fetch(routes.cart_url ? routes.cart_url + '.js' : '/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          $all('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        }).catch(function () {});
    },
    add: function (items, openAfter) {
      var btns = [];
      return fetch(cartAddUrl + '.js', fetchConfig({ items: items, sections: 'cart-drawer', sections_url: location.pathname }))
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) { // error payload
            console.warn('iWine cart add error:', data.description || data.message);
            return data;
          }
          Cart.render(data.sections);
          if (openAfter !== false) Cart.open();
          return data;
        })
        .catch(function (err) { console.warn('iWine cart add failed:', err); return { status: 'error' }; });
    },
    change: function (payload) {
      payload.sections = 'cart-drawer';
      payload.sections_url = location.pathname;
      return fetch(cartChangeUrl + '.js', fetchConfig(payload))
        .then(function (r) { return r.json(); })
        .then(function (data) { Cart.render(data.sections); })
        .catch(function (err) { console.warn('iWine cart change failed:', err); });
    },
    /* Sync a change to the server without re-rendering the drawer (no flash).
       Used when the DOM was already updated optimistically and indices are unchanged. */
    changeQuiet: function (payload) {
      return fetch(cartChangeUrl + '.js', fetchConfig(payload))
        .then(function (r) { return r.json(); })
        .then(function () { Cart.refreshCount(); })
        .catch(function (err) { console.warn('iWine cart change failed:', err); });
    },
    bind: function () { /* no-op: all cart controls use document-level delegation in initCart */ },
    /* Remove several lines at once (highest index first so lower indices don't shift),
       re-rendering once at the end. Used to drop a club line together with its Drink Rare upgrade. */
    removeLines: function (lines) {
      lines = lines.slice().sort(function (a, b) { return b - a; });
      var seq = Promise.resolve();
      lines.forEach(function (ln, i) {
        var last = i === lines.length - 1;
        seq = seq.then(function () {
          var body = last ? { line: ln, quantity: 0, sections: 'cart-drawer', sections_url: location.pathname } : { line: ln, quantity: 0 };
          return fetch(cartChangeUrl + '.js', fetchConfig(body)).then(function (r) { return r.json(); })
            .then(function (data) { if (last) Cart.render(data.sections); });
        });
      });
      return seq.catch(function (err) { console.warn('iWine removeLines failed:', err); });
    },
    /* Switch frequency: scale the club line (and any Drink Rare line) quantity to the
       number of months, so per-shipment price scales (x2 for 2-monthly, x3 for quarterly). */
    setFrequency: function (line, plan, months, rareLine, rarePlan) {
      months = months || 1;
      var seq = Promise.resolve();
      if (rareLine) {
        var rbody = { line: rareLine, quantity: months };
        if (rarePlan) rbody.selling_plan = rarePlan;
        seq = fetch(cartChangeUrl + '.js', fetchConfig(rbody)).then(function (r) { return r.json(); });
      }
      return seq.then(function () {
        return fetch(cartChangeUrl + '.js', fetchConfig({ line: line, selling_plan: plan, quantity: months, sections: 'cart-drawer', sections_url: location.pathname }));
      }).then(function (r) { return r.json(); }).then(function (data) {
        Cart.render(data.sections);
      }).catch(function (err) { console.warn('iWine setFrequency failed:', err); });
    }
  };
  window.iWineCart = Cart;

  /* Build a cart line instantly from data-* on the button, so the wine appears the moment
     you click, before the server responds. Cart.render reconciles it ~moments later. */
  function optimisticLineHTML(d, qty) {
    var img = d.image ? '<img src="' + escHtml(d.image) + '" alt="">' : '';
    return '<div class="iw-citem" data-optimistic>'
      + '<a href="' + escHtml(d.url || '#') + '" class="iw-citem__thumb">' + img + '</a>'
      + '<div class="iw-citem__body">'
      +   '<div class="iw-citem__top"><p class="iw-citem__meta">' + escHtml(d.meta || d.vendor || '') + '</p></div>'
      +   '<a href="' + escHtml(d.url || '#') + '" class="iw-citem__namelink"><h4 class="iw-citem__name">' + escHtml(d.title) + '</h4></a>'
      +   '<div class="iw-citem__row">'
      +     '<div class="iw-citem__qty"><button type="button" disabled aria-hidden="true">&#8211;</button><span data-qty-display>' + qty + '</span><button type="button" disabled aria-hidden="true">+</button></div>'
      +     '<span class="iw-citem__line">' + fmtMoney(d.price * qty) + '</span>'
      +   '</div>'
      + '</div></div>';
  }

  function optimisticAdd(btn, qty) {
    var d = {
      title: btn.getAttribute('data-product-title'),
      url: btn.getAttribute('data-product-url'),
      image: btn.getAttribute('data-product-image'),
      meta: btn.getAttribute('data-product-meta'),
      vendor: btn.getAttribute('data-product-vendor'),
      price: parseInt(btn.getAttribute('data-product-price'), 10) || 0
    };
    if (!d.title || !d.price) return;            // not enough data: fall back to server render
    var drawer = $('#iw-cart-drawer');
    if (!drawer) return;
    var line = optimisticLineHTML(d, qty);
    var body = $('.iw-cart__body', drawer);
    if (body) {
      var note = $('.iw-cart__note', body);
      if (note) { note.insertAdjacentHTML('beforebegin', line); }
      else { body.insertAdjacentHTML('beforeend', line); }
      bumpSubtotal(d.price * qty);
    } else {
      var empty = $('.iw-cart-empty', drawer);
      if (empty) {
        empty.outerHTML = '<div class="iw-cart__body">' + line + '</div>'
          + '<div class="iw-cart__foot"><div class="iw-cart__subtotal"><span>Subtotal</span>'
          + '<b data-cart-subtotal data-cents="' + (d.price * qty) + '">' + fmtMoney(d.price * qty) + '</b></div></div>';
      }
    }
    $all('[data-cart-count]').forEach(function (el) { el.textContent = (parseInt(el.textContent, 10) || 0) + qty; });
  }

  function addFromButton(btn) {
    if (btn.disabled) return;
    var id = btn.getAttribute('data-variant-id');
    if (!id) return;
    var openAfter = btn.getAttribute('data-open-cart') !== 'false';
    var qty = parseInt(btn.getAttribute('data-quantity'), 10) || 1;
    if (openAfter) { Cart.open(); optimisticAdd(btn, qty); }     // optimistic: line appears instantly
    if (btn.classList.contains('iw-toggle')) btn.setAttribute('aria-pressed', 'true'); // optimistic toggle
    var item = { id: id, quantity: qty };
    var sp = btn.getAttribute('data-selling-plan');
    if (sp) item.selling_plan = sp;
    var props = btn.getAttribute('data-properties');
    if (props) { try { item.properties = JSON.parse(props); } catch (er) {} }
    btn.disabled = true;
    Cart.add([item], openAfter).then(function (data) {
      btn.disabled = false;
      if (data && data.status) {
        var fb = btn.getAttribute('data-fallback-url');
        if (fb) { window.location.href = fb; }
      }
    });
  }

  function initCart() {
    if (initCart._done) return; // delegated listeners attach once
    initCart._done = true;
    // Esc closes
    on(document, 'keydown', function (e) { if (e.key === 'Escape') Cart.close(); });

    // ONE delegated click handler. Works for elements added later (drawer re-renders, theme editor, etc.)
    on(document, 'click', function (e) {
      var t;
      if ((t = e.target.closest('[data-cart-open]'))) { e.preventDefault(); Cart.refreshCount(); Cart.open(); return; }
      if ((t = e.target.closest('[data-cart-close]'))) { Cart.close(); return; }
      if (e.target.closest('[data-cart-scrim]')) { Cart.close(); return; }

      /* Drink Rare toggle: optimistic flip + subtotal, sync in background */
      if ((t = e.target.closest('[data-rare-toggle]'))) {
        var rli = t.closest('[data-line-item]');
        var rmonths = rli ? (parseInt(rli.getAttribute('data-months'), 10) || 1) : 1;
        if (t.getAttribute('data-rare-toggle') === 'on') {
          t.setAttribute('aria-pressed', 'true');
          if (rli) { bumpSubtotal(attrCents(rli, 'data-rare-monthly') * rmonths); rli.setAttribute('data-rare-active', 'true'); }
          var ritem = { id: t.getAttribute('data-variant-id'), quantity: rmonths };
          var rsp = t.getAttribute('data-selling-plan'); if (rsp) ritem.selling_plan = rsp;
          Cart.add([ritem], false);
        } else {
          t.setAttribute('aria-pressed', 'false');
          if (rli) { bumpSubtotal(-attrCents(rli, 'data-rare-cents')); rli.setAttribute('data-rare-active', 'false'); }
          Cart.change({ line: parseInt(t.getAttribute('data-rare-line'), 10), quantity: 0 });
        }
        return;
      }

      /* Remove a line: collapse it instantly, drop its price from the subtotal, sync in background */
      if ((t = e.target.closest('[data-line-remove]'))) {
        var li = t.closest('[data-line-item]');
        if (li) { bumpSubtotal(-attrCents(li, 'data-cents')); li.classList.add('iw-removing'); }
        var remLine = parseInt(t.getAttribute('data-line'), 10);
        var remRare = parseInt(t.getAttribute('data-rare-line'), 10) || 0;
        if (remRare > 0 && remRare !== remLine) {
          Cart.removeLines([remLine, remRare]); // drop the club line and its Drink Rare upgrade together
        } else {
          Cart.change({ line: remLine, quantity: 0 });
        }
        return;
      }

      if ((t = e.target.closest('[data-line-change]'))) {
        var newQty = parseInt(t.getAttribute('data-qty'), 10);
        var lineNo = parseInt(t.getAttribute('data-line'), 10);
        var ci = t.closest('[data-line-item]');
        if (ci && newQty <= 0) {
          bumpSubtotal(-attrCents(ci, 'data-cents'));
          ci.classList.add('iw-removing');
          Cart.change({ line: lineNo, quantity: 0 }); // re-render to fix line indices
          return;
        }
        if (ci) {
          var unit = attrCents(ci, 'data-unit');
          var newLine = unit * newQty;
          bumpSubtotal(newLine - attrCents(ci, 'data-cents'));
          ci.setAttribute('data-cents', newLine);
          var qd = $('[data-qty-display]', ci); if (qd) qd.textContent = newQty;
          var lt = $('[data-line-total]', ci); if (lt) lt.textContent = fmtMoney(newLine);
          $all('[data-line-change]', ci).forEach(function (b) {
            var lbl = b.getAttribute('aria-label') || '';
            b.setAttribute('data-qty', lbl.indexOf('Decrease') > -1 ? newQty - 1 : newQty + 1);
          });
          Cart.changeQuiet({ line: lineNo, quantity: newQty }); // instant, no re-render flash
        } else {
          Cart.change({ line: lineNo, quantity: newQty });
        }
        return;
      }

      /* Frequency pill: optimistic active + price (club and Drink Rare scale by months) */
      if ((t = e.target.closest('[data-line-sellingplan]'))) {
        var seg = t.parentNode;
        if (seg) { $all('button', seg).forEach(function (b) { b.classList.remove('is-active'); }); }
        t.classList.add('is-active');
        var sli = t.closest('[data-line-item]');
        var months = parseInt(t.getAttribute('data-months'), 10) || 1;
        if (sli) {
          var clubMonthly = attrCents(sli, 'data-club-monthly');
          var oldMonths = parseInt(sli.getAttribute('data-months'), 10) || 1;
          var rareActive = sli.getAttribute('data-rare-active') === 'true';
          var rareMonthly = attrCents(sli, 'data-rare-monthly');
          var oldLine = attrCents(sli, 'data-cents');
          var newLine = clubMonthly * months;
          var delta = (newLine - oldLine) + (rareActive ? rareMonthly * (months - oldMonths) : 0);
          bumpSubtotal(delta);
          var totalEl = $('[data-line-total]', sli);
          if (totalEl) totalEl.innerHTML = fmtMoney(newLine) + ' <span>/ shipment</span>';
          sli.setAttribute('data-cents', newLine);
          sli.setAttribute('data-months', months);
          if (rareActive) { sli.setAttribute('data-rare-cents', rareMonthly * months); }
        }
        Cart.setFrequency(
          parseInt(t.getAttribute('data-line'), 10),
          t.getAttribute('data-selling-plan') || null,
          months,
          parseInt(t.getAttribute('data-rare-line'), 10) || 0,
          t.getAttribute('data-rare-plan') || null
        );
        return;
      }

      if ((t = e.target.closest('[data-add-to-cart]'))) { e.preventDefault(); if (t.disabled || t.getAttribute('aria-disabled') === 'true') return; addFromButton(t); return; }
    });
  }

  /* ============================================================
     QTY STEPPERS (product form)
     ============================================================ */
  function initQty() {
    $all('[data-qty-wrap]').forEach(function (wrap) {
      var input = $('input', wrap);
      on($('[data-qty-dec]', wrap), 'click', function () {
        var v = Math.max(parseInt(input.min || '1', 10), (parseInt(input.value, 10) || 1) - 1);
        input.value = v; input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      on($('[data-qty-inc]', wrap), 'click', function () {
        var v = (parseInt(input.value, 10) || 1) + 1;
        input.value = v; input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  /* ============================================================
     PRODUCT PAGE PRICE: reflect quantity instantly
     ============================================================ */
  function initPdpPrice() {
    var priceEl = $('[data-pdp-price]');
    var input = $('[data-product-form] input[name="quantity"]');
    if (!priceEl || !input) return;
    var unit = parseInt(priceEl.getAttribute('data-unit'), 10) || 0;
    var suffix = $('[data-pdp-price-suffix]');
    function update() {
      var q = parseInt(input.value, 10) || 1;
      priceEl.textContent = fmtMoney(unit * q);
      if (suffix) suffix.style.display = q > 1 ? 'none' : '';
    }
    on(input, 'change', update);
    on(input, 'input', update);
  }

  /* ============================================================
     PRODUCT FORM (variant + selling plan aware)
     ============================================================ */
  function initProductForm() {
    $all('[data-product-form]').forEach(function (form) {
      var addBtn = $('[data-product-add]', form);
      on(form, 'submit', function (e) {
        e.preventDefault();
        Cart.open(); // optimistic: drawer slides in instantly
        var fd = new FormData(form);
        var item = { id: fd.get('id'), quantity: parseInt(fd.get('quantity'), 10) || 1 };
        var sp = fd.get('selling_plan');
        if (sp) item.selling_plan = sp;
        // collect line item properties
        var props = {};
        $all('[name^="properties["]', form).forEach(function (inp) {
          if (inp.type === 'checkbox' && !inp.checked) return;
          var m = inp.name.match(/properties\[(.+)\]/);
          if (m) props[m[1]] = inp.value;
        });
        if (Object.keys(props).length) item.properties = props;
        if (addBtn) addBtn.disabled = true;
        Cart.add([item], true).then(function () { if (addBtn) addBtn.disabled = false; });
      });
    });
  }

  /* ============================================================
     EXPLORE — sort dropdown + mobile filter drawer
     ============================================================ */
  function initFilters() {
    // Sort: reload with the chosen sort_by, preserving other query params
    var sortSel = $('[data-sort-by]');
    if (sortSel) {
      on(sortSel, 'change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortSel.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }
    // Mobile filter drawer
    var openBtn = $('[data-facets-open]');
    if (openBtn) on(openBtn, 'click', function () { document.body.classList.add('iw-facets-open'); });
    $all('[data-facets-close]').forEach(function (b) {
      on(b, 'click', function () { document.body.classList.remove('iw-facets-open'); });
    });
    on(document, 'keydown', function (e) { if (e.key === 'Escape') document.body.classList.remove('iw-facets-open'); });
  }

  /* ============================================================
     STICKY BUY BAR (product page): slide in when main buy scrolls away
     ============================================================ */
  function initBuyBar() {
    var bar = $('[data-buybar]');
    var anchor = $('[data-buy-anchor]');
    if (!bar || !anchor) return;
    if (!('IntersectionObserver' in window)) return;
    if (bar._io) return; // bind once
    bar._io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        // Show the bar only once the main buy action has scrolled up out of view
        var below = en.boundingClientRect.top > 0;
        if (en.isIntersecting || below) { bar.classList.remove('is-visible'); }
        else { bar.classList.add('is-visible'); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0 });
    bar._io.observe(anchor);
  }

  /* ============================================================
     CLUB PATH CARDS -> add club product w/ selling plan, open cart
     ============================================================ */
  function initClub() {
    $all('[data-club-path]').forEach(function (card) {
      on(card, 'click', function (e) {
        e.preventDefault();
        var id = card.getAttribute('data-variant-id');
        if (!id) return;
        var item = { id: id, quantity: 1, properties: { 'Path': card.getAttribute('data-path-label') || 'The Red' } };
        var sp = card.getAttribute('data-selling-plan');
        if (sp) item.selling_plan = sp;
        Cart.add([item], true);
      });
    });
  }

  /* ============================================================
     GLOBAL SEARCH (predictive overlay: wines, stories, pages)
     ============================================================ */
  function escHtml(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); }

  function initSearch() {
    var root = $('[data-search]');
    if (!root || root._init) return;
    root._init = true;
    var input = $('[data-search-input]', root);
    var results = $('[data-search-results]', root);
    var hint = '<p class="iw-search__hint">Try a producer, a region, or a vintage.</p>';
    var suggestUrl = routes.predictive_search_url || '/search/suggest';
    var searchUrl = routes.search_url || '/search';
    var timer = null, lastQ = '';

    function open() {
      document.body.classList.add('iw-search-open');
      root.setAttribute('aria-hidden', 'false');
      setTimeout(function () { try { input.focus(); } catch (e) {} }, 60);
    }
    function close() {
      document.body.classList.remove('iw-search-open');
      root.setAttribute('aria-hidden', 'true');
    }

    function imgUrl(u) { if (!u) return ''; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=120'; }

    function isHidden(p) {
      var t = p && p.tags;
      if (!t) return false;
      if (typeof t === 'string') { t = t.split(','); }
      if (!t.map) return false;
      return t.map(function (s) { return String(s).trim().toLowerCase(); }).indexOf('hidden') > -1;
    }

    function render(data, q) {
      var r = (data && data.resources && data.resources.results) || {};
      var products = (r.products || []).filter(function (p) { return !isHidden(p); });
      var articles = r.articles || [], pages = r.pages || [];
      var html = '';
      if (products.length) {
        html += '<div class="iw-search__group"><p class="iw-search__grouphead">Wines</p><div class="iw-search__items">';
        products.forEach(function (p) {
          var img = imgUrl((p.featured_image && p.featured_image.url) || p.image || '');
          html += '<a class="iw-search__item" href="' + escHtml(p.url) + '">'
            + '<span class="iw-search__thumb">' + (img ? '<img src="' + escHtml(img) + '" alt="" loading="lazy">' : '') + '</span>'
            + '<span class="iw-search__info"><span class="iw-search__name">' + escHtml(p.title) + '</span>'
            + (p.vendor ? '<span class="iw-search__meta">' + escHtml(p.vendor) + '</span>' : '')
            + '</span></a>';
        });
        html += '</div></div>';
      }
      if (articles.length) {
        html += '<div class="iw-search__group"><p class="iw-search__grouphead">Stories</p><div class="iw-search__items">';
        articles.forEach(function (a) {
          html += '<a class="iw-search__item iw-search__item--text" href="' + escHtml(a.url) + '"><span class="iw-search__name">' + escHtml(a.title) + '</span></a>';
        });
        html += '</div></div>';
      }
      if (pages.length) {
        html += '<div class="iw-search__group"><p class="iw-search__grouphead">Pages</p><div class="iw-search__items">';
        pages.forEach(function (pg) {
          html += '<a class="iw-search__item iw-search__item--text" href="' + escHtml(pg.url) + '"><span class="iw-search__name">' + escHtml(pg.title) + '</span></a>';
        });
        html += '</div></div>';
      }
      if (!html) {
        results.innerHTML = '<p class="iw-search__empty">Nothing in the cellar matched &ldquo;' + escHtml(q) + '&rdquo;. Try a cru, a region, or a vintage.</p>';
        return;
      }
      html += '<a class="iw-search__all" href="' + escHtml(searchUrl) + '?q=' + encodeURIComponent(q) + '&type=product,article,page">See all results for &ldquo;' + escHtml(q) + '&rdquo; &rarr;</a>';
      results.innerHTML = html;
    }

    function query(q) {
      var url = suggestUrl + '?q=' + encodeURIComponent(q)
        + '&resources[type]=product,article,page&resources[limit]=6'
        + '&resources[options][unavailable_products]=last';
      fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (data) { if (input.value.trim() === q) render(data, q); })
        .catch(function () {});
    }

    on(input, 'input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { results.innerHTML = hint; lastQ = ''; return; }
      if (q === lastQ) return;
      lastQ = q;
      timer = setTimeout(function () { query(q); }, 180);
    });

    $all('[data-search-open]').forEach(function (b) { on(b, 'click', function (e) { e.preventDefault(); open(); }); });
    $all('[data-search-close]', root).forEach(function (b) { on(b, 'click', function () { close(); }); });
    on(document, 'keydown', function (e) { if (e.key === 'Escape' && document.body.classList.contains('iw-search-open')) close(); });
  }

  /* ============================================================
     AGE VERIFICATION GATE (yes / no, remembered)
     ============================================================ */
  function initAgeGate() {
    var gate = $('[data-age-gate]');
    if (!gate || gate._init) return;
    gate._init = true;
    var verified = false;
    try { verified = localStorage.getItem('iw-age-ok') === '1'; } catch (e) {}
    if (verified) { document.documentElement.classList.add('iw-age-ok'); return; }
    document.body.classList.add('iw-age-open');
    on($('[data-age-yes]', gate), 'click', function () {
      try { localStorage.setItem('iw-age-ok', '1'); } catch (e) {}
      document.documentElement.classList.add('iw-age-ok');
      document.body.classList.remove('iw-age-open');
    });
    on($('[data-age-no]', gate), 'click', function () {
      // Not of age: do NOT remember the choice, so the gate returns next visit. Send them away.
      window.location.href = gate.getAttribute('data-decline-url') || 'https://liquiddeath.com';
    });
  }

  /* ============================================================
     BOOT
     ============================================================ */
  function boot() {
    initReveal();
    initAnnounce();
    initMobileNav();
    initCart();
    initQty();
    initPdpPrice();
    initProductForm();
    initClub();
    initFilters();
    initBuyBar();
    initSearch();
    initAgeGate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }

  // Re-run reveal when Shopify theme editor injects sections
  document.addEventListener('shopify:section:load', function () { initReveal(); initCart(); initQty(); initPdpPrice(); initProductForm(); initClub(); initFilters(); initBuyBar(); initSearch(); });
})();
